import { trackStructuredEvent } from 'js/helpers/google-tag-manager';
import { featureFlagExperiments } from 'js/helpers/feature-flags';

function trackEvent(experimentName: string, label: string): void {
  trackStructuredEvent({
    category: 'experimentation',
    property: experimentName,
    action: 'flipper_test_loaded',
    label,
  });
}

export function trackFeatureFlagExperiments(featureFlags: string): void {
  const experiments = featureFlagExperiments(featureFlags);
  const names = [...Object.keys(experiments)];
  for (const name of names) {
    trackEvent(name, experiments[name] || '0');
  }
}
